import type {Command, EditorView} from '@codemirror/view'

import {getNodeAtOffset} from '../../language-tools/syntax-tree/node-range-utils'
import {getMarkdownTree} from '../extensions/markdown-parser'

export const visitIfLink: Command = (view: EditorView) => {
  const caretLocation = view.state.selection.main.anchor
  const tree = getMarkdownTree(view.state)

  const nodeWithCaret = getNodeAtOffset(tree, caretLocation)

  if (nodeWithCaret?.type === 'link') {
    window.open(nodeWithCaret.url, '_blank', 'noopener,noreferrer')
    return true
  }
  return false
}
